import { z } from "zod";

/**
 * The fields of a finding a client actually reads. Each has its own length
 * budget and its own rewriting rules, so the set is named rather than spelled
 * out beside every table that keys on it.
 */
export const CLIENT_FINDING_FIELDS = ["title", "summary", "action"] as const;
export const ClientFindingFieldSchema = z.enum(CLIENT_FINDING_FIELDS);
export type ClientFindingField = z.infer<typeof ClientFindingFieldSchema>;
export const CLIENT_FINDING_FIELD = {
  TITLE: "title",
  SUMMARY: "summary",
  ACTION: "action",
} as const satisfies Record<string, ClientFindingField>;
